const islandsData = {
    islands: [
        {
            name: 'Touchdown',
            lives: 10,
            towns: {
                small: 0,
                medium: 0,
                large: 0
            },
            size: 40,
            loot: 100
        },
        {
            name: 'Dacaria',
            lives: 100,
            towns: {
                small: 0,
                medium: 0,
                large: 0
            }
        },
        {
            name: 'Island 3',
            lives: 1000,
            towns: {
                small: 0,
                medium: 0,
                large: 0
            }
        },
        {
            name: 'Island 4',
            lives: 10000,
            towns: {
                small: 0,
                medium: 0,
                large: 0
            }
        },
        {
            name: 'Island 5',
            lives: 100000,
            towns: {
                small: 0,
                medium: 0,
                large: 0
            }
        },
        {
            name: 'Island 6',
            lives: 1000000,
            towns: {
                small: 0,
                medium: 0,
                large: 0
            }
        },
        {
            name: 'Island 7',
            lives: 10000000,
            towns: {
                small: 0,
                medium: 0,
                large: 0
            }
        }
    ]
};

export default islandsData;
